import { ReactElement } from 'react';
import BackButton from '@root/src/app/designSystem/buttons/backButton';
import Lang from '@lang/en';
import { CloudIconNew } from '@root/src/assets/images';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import {
  LastUpdate,
  LastUpdateDateSpan,
  LastUpdateSpan,
  MenuStyle,
} from './styles';
import {
  dateTime24FriendlyFormatWithComma,
  formatUTCStringAsApiTimestamp,
} from '@app/utils';

interface PersonProps {
  data: OrderDetailsI;
}

const InfoPanel = ({ data }: PersonProps): ReactElement => {
  const updatedAt = formatUTCStringAsApiTimestamp(
    data.updatedAt,
    dateTime24FriendlyFormatWithComma
  );

  return (
    <MenuStyle>
      <BackButton data-testid="healthcheck-order-back-button" to="/dashboard" />
      <LastUpdate>
        <CloudIconNew />
        <LastUpdateSpan className="last-updated">
          {Lang.healthCheckDetailsLastUpdate}
        </LastUpdateSpan>
        <LastUpdateDateSpan className="last-update-date">
          {updatedAt}
        </LastUpdateDateSpan>
      </LastUpdate>
    </MenuStyle>
  );
};

export default InfoPanel;
